import { xlCol, xlColq } from "../../../common/constants"
import { DEMO_COMPANY, GUJRAT_COMPANY_ID } from "../../../../helper/companyIdhardcode"

export const cargoUnloadingTblDefs = (intCompanyID) => [
    { header: 'LR No.',exportHead: 'LR No.', field: 'LRNO', isSortIcon: true, weight:20, xlCol: xlCol,  },
    { header: 'From City',exportHead: 'From City', field: 'FromCity', isSortIcon: true, weight:30, xlCol: xlCol,  },
    { header: 'To City',exportHead: 'To City', field: 'ToCity', isSortIcon: true, weight:30, xlCol: xlCol,  },
    [DEMO_COMPANY, GUJRAT_COMPANY_ID].includes(intCompanyID) && {
      header: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentTypeName', isSortIcon: true,  weight: 30, xlCol: xlCol,
    },
    { header: 'Sender Name',exportHead: 'Sender Name', field: 'Sender', isSortIcon: true, weight:50, xlCol: xlCol,  },
    { header: 'Receiver Name',exportHead: 'Receiver Name', field: 'Receiver', isSortIcon: true, weight:50, xlCol: xlCol,  },
    { header: 'NOP',exportHead: 'NOP', field: 'NOP', isSortIcon: true, weight:18, xlCol: xlColq, },
    { header: 'Charged Weight',exportHead: 'Charged Weight', field: 'CHARGEDWEIGHT', isSortIcon: true, weight:33, xlCol: xlColq, },
    { header: 'Freight Charge',exportHead: 'Freight Charge', field: 'FREIGHT', isSortIcon: true, weight:32, xlCol: xlColq, },
    { header: 'Total Amount',exportHead: 'Total Amount', field: 'NETAMOUNT', isSortIcon: true, weight:30, xlCol: xlColq, },
    { header: 'LR Status',exportHead: 'LR Status', field: 'status', isSortIcon: true, weight:30, xlCol: xlCol,  },
  ].filter(Boolean)
export const headerData = [
    { header: 'Dispatch Data',exportHead: 'Dispatch Data', field: 'dispatchDate',weight:30, xlCol: xlCol,  },
    { header: 'From Branch',exportHead: 'From Branch', field: 'branch',weight:30, xlCol: xlCol,  },
    { header: 'Vehicle No.',exportHead: 'Vehicle No.', field: 'vehicleNo',weight:30, xlCol: xlCol,  },
  ]

  export const headerTblDefs = [
    { header: 'Dispatch Date', field: 'fromDate', xlCol: xlCol },
    { header: 'Branch Name', field: 'branchName', xlCol: xlCol },
    { header: 'Vehicle No.', field: 'vehicleNo', xlCol: xlCol },
  ]

  export const cargoUnloadingTblStyles = {
    0: {cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    1: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    2: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    3: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    4: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    5: { cellWidth: 117.99, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    6: { cellWidth: 117.99, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    7: { cellWidth: 117.99, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    8: { cellWidth: 117.99, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    9: { cellWidth: 117.99, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
  }
  export const cargoUnloadingStylesWithFormattedLR = {
    0: {cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    1: {cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    2: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    3: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    4: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    5: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    6: { cellWidth: 107.26, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    7: { cellWidth: 107.26, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    8: { cellWidth: 107.26, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    9: { cellWidth: 107.26, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    10: { cellWidth: 107.26, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
  }
  export const cellStyles = {
    minCellHeightheight: '50px',
    padding: '7px 12px',
    alignItems: 'flexStart',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    whiteSpace: "nowrap",
    verticalAlign: 'top',
    textAlign: 'left',
  }
  export const totalRowStyles = {
    height: '36px',
    padding: '7px 12px',
    backgroundColor: "#eeeeee",
    textAlign: "right",
    color: '#444444',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  }
  export const headCellStyles = {
    borderStyle: 'solid',
    borderWidth: '0px 0px',
    backgroundColor: "#BFE1FF",
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 600,
    minCellHeight: '44px',
    padding: '7px 12px 7px 12px',
    whiteSpace: "nowrap",
    verticalAlign: 'top',
    color:'#444444'
  }